// Pastel colors for user avatars
export const PASTEL_COLORS = [
  { bg: 'bg-[#F5C8BD]', hex: '#F5C8BD' },
  { bg: 'bg-[#E9BACC]', hex: '#E9BACC' },
  { bg: 'bg-[#D0AAB0]', hex: '#D0AAB0' },
  { bg: 'bg-[#B599C1]', hex: '#B599C1' },
  { bg: 'bg-[#ABACCB]', hex: '#ABACCB' },
  { bg: 'bg-[#9FBFDD]', hex: '#9FBFDD' },
  { bg: 'bg-[#97CCDC]', hex: '#97CCDC' },
  { bg: 'bg-[#83C4B4]', hex: '#83C4B4' },
  { bg: 'bg-[#A9D194]', hex: '#A9D194' },
  { bg: 'bg-[#D5E4AD]', hex: '#D5E4AD' },
  { bg: 'bg-[#FAEEAE]', hex: '#FAEEAE' },
  { bg: 'bg-[#F5BE6B]', hex: '#F5BE6B' }
];

// File type configurations for icons and colors
export const FILE_TYPES = {
  PDF: {
    extensions: ['.pdf'],
    bgColor: 'bg-orange-500',
    iconType: 'document'
  },
  CODE: {
    extensions: [
      '.js', '.jsx', '.ts', '.tsx', '.py', '.java', '.cpp', '.c', '.cs', 
      '.php', '.rb', '.go', '.rs', '.swift', '.kt', '.scala', '.r', '.m',
      '.html', '.css', '.scss', '.sass', '.less', '.json', '.xml', 
      '.yaml', '.yml', '.sql', '.sh', '.bat', '.ps1'
    ],
    bgColor: 'bg-pink-500',
    iconType: 'code'
  },
  WORD: {
    extensions: ['.doc', '.docx', '.rtf', '.odt'],
    bgColor: 'bg-blue-500',
    iconType: 'text'
  },
  OTHER_DOCS: {
    extensions: [
      '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.csv', '.ods', '.odp'
    ],
    bgColor: 'bg-orange-500',
    iconType: 'document'
  },
  DEFAULT: {
    bgColor: 'bg-gray-500',
    iconType: 'document'
  }
};

// Loading indicator types
export const LOADING_TYPES = {
  DOCUMENT_ANALYSIS: 'document_analysis',
  WEB_SEARCH: 'web_search',
  HUBSPOT_SEARCH: 'hubspot_search',
  IMAGE_GENERATION: 'image_generation',
  DEEP_RESEARCH: 'deep_research'
}; 